var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResumeFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-69"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "339.2 367.82 336.94 465.63 332.63 465.63 332.9 368.07 339.2 367.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.78 366.74 375.76 465.63 380.56 465.63 363.11 366.74 354.78 366.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.47 367.82 292.26 465.63 287.45 465.63 308.51 367.43 315.47 367.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.33,267.86s25.13-1.44,22.62,27.65S395,354,385.66,364.09s-103.41,10.42-111.32,2.16,15.09-7.9,19.4-7.9,30.88,2.51,39.5-20.11S339.7,266.42,376.33,267.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.94,267.87s19.21,3.94,17.42,24.05-6.83,55.3-16.16,64.27-45.92,10.94-65.71,9.7c-23-1.44-37.49-5.81-37.49-5.81s-4.2,2.69-2.93,4.43,12.48,8.72,66.8,7.56,50.54-9.18,52.8-17.93,7-55.43,6.32-65.69S393.17,269.67,377.94,267.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.17,307a2.15,2.15,0,1,0,2.08-2.66A2.43,2.43,0,0,0,362.17,307Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.59,295.25a15.59,15.59,0,0,0-.71,3.87,9.24,9.24,0,0,0,.92,4.08,8.79,8.79,0,0,0,1.37,2,10,10,0,0,1,1,1,2.09,2.09,0,0,1,.36,1.6,19,19,0,0,1-1.07,2.61,8,8,0,0,0-.31,2.42,9,9,0,0,0,1.05,4,15.3,15.3,0,0,0,2.42,3.1s-.37-.13-.92-.57a8.74,8.74,0,0,1-2-2.28,9.16,9.16,0,0,1-1.26-4.28,8.4,8.4,0,0,1,.3-2.67,20.74,20.74,0,0,0,1-2.5c.19-.79-.46-1.36-1.12-2a9,9,0,0,1-1.46-2.24,9.39,9.39,0,0,1-.83-4.38,8.79,8.79,0,0,1,.67-2.92C363.32,295.54,363.55,295.23,363.59,295.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.9,303.57c.12,0,0,.63.29,1.52a5.33,5.33,0,0,0,2.09,2.82,8.4,8.4,0,0,0,3.42,1.22c.94.14,1.55.16,1.56.27s-.6.25-1.61.23a6.9,6.9,0,0,1-3.77-1.13,5.09,5.09,0,0,1-2.19-3.3C357.53,304.16,357.82,303.54,357.9,303.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.79 466.5 423.54 466.49 417.61 323.11 413.87 323.31 419.79 466.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.68 466.66 215.42 466.88 222.46 323.48 218.72 323.25 211.68 466.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.53 467.57 250.27 467.8 257.12 325.42 253.39 325.19 246.53 467.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.22 466.49 446.97 466.49 440.96 323.24 437.22 323.44 443.22 466.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.32,
    y: 321.56,
    width: 245.52,
    height: 7.38,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.2 274.36 241.75 320.72 321.21 320.72 320.62 318.33 288.49 317.43 273.69 274.34 224.2 274.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.41,297.49a3.21,3.21,0,0,1-2,4.16,3.48,3.48,0,0,1-3.91-2.73,3.21,3.21,0,0,1,2-4.15A3.46,3.46,0,0,1,259.41,297.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.15,466.49c0,.16-95.65.28-213.61.28s-213.62-.12-213.62-.28,95.62-.27,213.62-.27S460.15,466.34,460.15,466.49Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Documents--inject-69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 87.31,
    width: 27.99,
    height: 38.54,
    transform: "translate(699.99 213.15) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.59,95.07c0,.06-2,.1-4.47.1s-4.48,0-4.48-.1,2-.11,4.48-.11S359.59,95,359.59,95.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.12,100.12a22.86,22.86,0,0,1-4.48,0,25.14,25.14,0,0,1,4.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.35,101.59a25,25,0,0,1-4.47,0,22.76,22.76,0,0,1,4.47,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.65,103.74a57.34,57.34,0,0,1-6.77,0,57.34,57.34,0,0,1,6.77,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.35,107.41a25,25,0,0,1-4.47,0,22.76,22.76,0,0,1,4.47,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.65,109.56a57.34,57.34,0,0,1-6.77,0,52.14,52.14,0,0,1,6.77,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.35,113a25,25,0,0,1-4.47,0,22.76,22.76,0,0,1,4.47,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.65,115.11a57.34,57.34,0,0,1-6.77,0,57.34,57.34,0,0,1,6.77,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.84,103.87c0,.06-2.28.1-5.1.1s-5.1,0-5.1-.1,2.29-.1,5.1-.1S360.84,103.81,360.84,103.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.68,107.62a20.45,20.45,0,0,1-4,0,18.6,18.6,0,0,1,4,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.84,111.36c0,.06-2.28.11-5.1.11s-5.1,0-5.1-.11,2.29-.1,5.1-.1S360.84,111.31,360.84,111.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.84,115.11c0,.06-2.28.1-5.1.1s-5.1,0-5.1-.1,2.29-.1,5.1-.1S360.84,115.05,360.84,115.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.31,119c0,.06-2.29.11-5.1.11s-5.1,0-5.1-.11,2.28-.1,5.1-.1S360.31,119,360.31,119Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.35,98.83s0-.19,0-.54,0-.92,0-1.49c0-1.4,0-3.18-.05-5.27l.09.09h-7.3s.19-.2.1-.1h0v3.85c0,1.22,0,2.37,0,3.44l-.09-.09,5.26.05,1.5,0,.54,0a4.79,4.79,0,0,1-.5,0l-1.48,0-5.32,0H340v-.09c0-1.07,0-2.22,0-3.44V91.54h0l.11-.11,7.3,0h.09v.09c0,2.11,0,3.91,0,5.32,0,.57,0,1.05,0,1.48A4.79,4.79,0,0,1,347.35,98.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.35,94.81a2.14,2.14,0,0,1-.38-.22l-1-.67h.1l-2.25,2.18-.05,0-.06.06-.07,0-1.37-1h.12l-1.67,1.39a4.38,4.38,0,0,1-.67.5,4,4,0,0,1,.6-.59L342.27,95l.05-.05.07,0,1.37,1h-.13l.05,0c.79-.75,1.53-1.43,2.29-2.14l0,0,.06,0,.95.73A1.58,1.58,0,0,1,347.35,94.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.51,93.24a1.11,1.11,0,0,0-.39-.65.8.8,0,0,0-.76-.1.79.79,0,0,0,0,1.49.8.8,0,0,0,.76-.1,1.13,1.13,0,0,0,.39-.64s.12.38-.3.76a1,1,0,0,1-.92.16,1,1,0,0,1-.65-.92,1,1,0,0,1,1.57-.77C344.63,92.85,344.53,93.26,344.51,93.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.76,
    y: 87.31,
    width: 27.99,
    height: 38.54,
    transform: "translate(275.51 213.15) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35,95.07c0,.06-2,.1-4.47.1s-4.48,0-4.48-.1,2-.11,4.48-.11S147.35,95,147.35,95.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,100.12a22.86,22.86,0,0,1-4.48,0,25.14,25.14,0,0,1,4.48,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.11,101.59a25,25,0,0,1-4.47,0,22.76,22.76,0,0,1,4.47,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.41,103.74a27.42,27.42,0,0,1-3.38.1,27.53,27.53,0,0,1-3.39-.1,27.53,27.53,0,0,1,3.39-.1A27.42,27.42,0,0,1,134.41,103.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.11,107.41a25,25,0,0,1-4.47,0,22.76,22.76,0,0,1,4.47,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.41,109.56a27.42,27.42,0,0,1-3.38.1,27.53,27.53,0,0,1-3.39-.1,26.28,26.28,0,0,1,3.39-.11A26.18,26.18,0,0,1,134.41,109.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.11,113a25,25,0,0,1-4.47,0,22.76,22.76,0,0,1,4.47,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.41,115.11a27.42,27.42,0,0,1-3.38.1,27.53,27.53,0,0,1-3.39-.1A27.53,27.53,0,0,1,131,115,27.42,27.42,0,0,1,134.41,115.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,103.87c0,.06-2.28.1-5.1.1s-5.1,0-5.1-.1,2.29-.1,5.1-.1S148.6,103.81,148.6,103.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.45,107.62a20.55,20.55,0,0,1-4,0,18.69,18.69,0,0,1,4,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,111.36c0,.06-2.28.11-5.1.11s-5.1,0-5.1-.11,2.29-.1,5.1-.1S148.6,111.31,148.6,111.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,115.11c0,.06-2.28.1-5.1.1s-5.1,0-5.1-.1,2.29-.1,5.1-.1S148.6,115.05,148.6,115.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.07,119c0,.06-2.28.11-5.1.11s-5.1,0-5.1-.11,2.28-.1,5.1-.1S148.07,119,148.07,119Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.11,98.83s0-.19,0-.54,0-.92,0-1.49c0-1.4,0-3.18,0-5.27l.09.09h-7.3l.1-.1h0v3.85c0,1.22,0,2.37,0,3.44l-.09-.09,5.27.05,1.49,0,.54,0a4.55,4.55,0,0,1-.5,0l-1.48,0-5.32,0h-.09v-.09c0-1.07,0-2.22,0-3.44,0-.62,0-1.25,0-1.89v-2h0l.11-.11,7.3,0h.1v.09c0,2.11,0,3.91,0,5.32,0,.57,0,1.05,0,1.48S135.11,98.83,135.11,98.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.11,94.81a2.68,2.68,0,0,1-.38-.22l-1-.67h.09l-2.24,2.18-.06,0-.06.06-.07,0-1.37-1h.12l-1.67,1.39a4.38,4.38,0,0,1-.67.5,4.81,4.81,0,0,1,.6-.59L130,95l.05-.05.07,0,1.37,1h-.13l.05,0c.79-.75,1.53-1.43,2.29-2.14l.05,0,.05,0,.95.73A1.58,1.58,0,0,1,135.11,94.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.27,93.24a1.11,1.11,0,0,0-.39-.65.8.8,0,0,0-.76-.1.79.79,0,0,0,0,1.49.8.8,0,0,0,.76-.1,1.13,1.13,0,0,0,.39-.64s.13.38-.3.76a1,1,0,0,1-.92.16,1,1,0,0,1-.65-.92,1,1,0,0,1,1.57-.77C132.4,92.85,132.29,93.26,132.27,93.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.88,
    y: 47.67,
    width: 2.82,
    height: 2.82,
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.88,
    y: 89.27,
    width: 2.82,
    height: 2.82,
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.71,
    y: 89.27,
    width: 2.82,
    height: 2.82,
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.88,
    y: 130.19,
    width: 2.82,
    height: 2.82,
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.2,
    y: 47.67,
    width: 2.82,
    height: 2.82,
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.2,
    y: 130.87,
    width: 2.82,
    height: 2.82,
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.71,
    y: 47.67,
    width: 2.82,
    height: 2.82,
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.71,
    y: 130.87,
    width: 2.82,
    height: 2.82,
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.31,131.77s0-.14,0-.4l0-1.18c0-1.05,0-2.58,0-4.56,0-4,0-9.78-.07-17.12,0-14.65-.07-35.42-.12-59.94l.24.24-57.82,0h0l.26-.26c0,31.24,0,60.1-.05,83.2l-.21-.2,42,.1,11.65.06,3.07,0,1.06,0-1,0-3,0-11.61.05-42.17.11h-.21v-.22c0-23.1,0-52-.05-83.2v-.26h.26l57.82,0h.24v.24c-.05,24.58-.09,45.4-.12,60.1,0,7.31-.05,13.09-.06,17.06,0,2,0,3.47,0,4.51v1.15C276.32,131.65,276.31,131.77,276.31,131.77Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.75,
    y: 52.39,
    width: 53.18,
    height: 76.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.56,75.66a40.65,40.65,0,0,1-9.18,0,40.65,40.65,0,0,1,9.18,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,76.8a40.76,40.76,0,0,1-6.45.26,40.76,40.76,0,0,1-6.45-.26,40.76,40.76,0,0,1,6.45-.26A40.76,40.76,0,0,1,239.34,76.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,80.18a40.76,40.76,0,0,1-6.45.26,40.76,40.76,0,0,1-6.45-.26,39.38,39.38,0,0,1,6.45-.26A39.38,39.38,0,0,1,239.34,80.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,83.55a39.38,39.38,0,0,1-6.45.26,39.38,39.38,0,0,1-6.45-.26,40.76,40.76,0,0,1,6.45-.26A40.76,40.76,0,0,1,239.34,83.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,86.93a40.76,40.76,0,0,1-6.45.26,40.76,40.76,0,0,1-6.45-.26,40.76,40.76,0,0,1,6.45-.26A40.76,40.76,0,0,1,239.34,86.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,90.31a40.76,40.76,0,0,1-6.45.26,40.76,40.76,0,0,1-6.45-.26,39.38,39.38,0,0,1,6.45-.26A39.38,39.38,0,0,1,239.34,90.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,96.39a38.66,38.66,0,0,1-6.45.27,38.66,38.66,0,0,1-6.45-.27,40.76,40.76,0,0,1,6.45-.26A40.76,40.76,0,0,1,239.34,96.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,99.77a39.38,39.38,0,0,1-6.45.26,39.38,39.38,0,0,1-6.45-.26,40.76,40.76,0,0,1,6.45-.26A40.76,40.76,0,0,1,239.34,99.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.34,103.15a40.76,40.76,0,0,1-6.45.26,40.76,40.76,0,0,1-6.45-.26,40.76,40.76,0,0,1,6.45-.26A40.76,40.76,0,0,1,239.34,103.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.61,106.53a24.85,24.85,0,0,1-7.17,0,24.85,24.85,0,0,1,7.17,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.1,81.14c0,.14-4.64.26-10.36.26s-10.36-.12-10.36-.26,4.63-.26,10.36-.26S265.1,81,265.1,81.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.39,84.44c0,.14-4.64.26-10.36.26s-10.36-.12-10.36-.26A99.35,99.35,0,0,1,255,84.17,99.35,99.35,0,0,1,265.39,84.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.56,92a40.65,40.65,0,0,1-9.18,0,40.65,40.65,0,0,1,9.18,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.1,97.44a101.2,101.2,0,0,1-10.36.26,101,101,0,0,1-10.36-.26c0-.14,4.63-.26,10.36-.26S265.1,97.3,265.1,97.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.39,100.74c0,.14-4.64.26-10.36.26s-10.36-.12-10.36-.26a101.2,101.2,0,0,1,10.36-.26A101.2,101.2,0,0,1,265.39,100.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.56,108.9a40.65,40.65,0,0,1-9.18,0,40.65,40.65,0,0,1,9.18,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.1,114.38a101.2,101.2,0,0,1-10.36.26,101,101,0,0,1-10.36-.26c0-.14,4.63-.26,10.36-.26S265.1,114.24,265.1,114.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.39,117.68c0,.14-4.64.26-10.36.26s-10.36-.12-10.36-.26a101.2,101.2,0,0,1,10.36-.26A101.2,101.2,0,0,1,265.39,117.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.73,71.79a6.93,6.93,0,0,1,0-1c0-.72,0-1.65-.06-2.81,0-2.45-.07-5.82-.12-9.84l.23.23-13.67,0,.25-.25h0v7.2c0,2.29,0,4.45,0,6.45l-.23-.23,9.84.12,2.81.06a6.93,6.93,0,0,1,1,.05,9.12,9.12,0,0,1-.94,0L236,71.9l-10,.11h-.22v-.22c0-2,0-4.16,0-6.45V61.8c0-.6,0-1.21,0-1.83V58.14h0l.27-.27,13.67,0H240v.22c0,4.08-.08,7.5-.11,10,0,1.13-.05,2.05-.06,2.75A9.12,9.12,0,0,1,239.73,71.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,63.92c0,.15-4.91.26-11,.26s-11-.11-11-.26,4.91-.26,11-.26S268,63.78,268,63.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.24,67.08a29.53,29.53,0,0,1-5.48.26,29.44,29.44,0,0,1-5.48-.26,28.44,28.44,0,0,1,5.48-.26A28.53,28.53,0,0,1,257.24,67.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.45,61.13s-.33.3-1,.44a1.77,1.77,0,0,1-1.28-.23,1.88,1.88,0,0,1-.86-1.36,2,2,0,0,1,.52-1.52,1.86,1.86,0,0,1,1.16-.58c.76-.07,1.14.25,1.1.3s-.43-.08-1,.06a1.64,1.64,0,0,0-.87.54,1.53,1.53,0,0,0-.36,1.14,1.43,1.43,0,0,0,.61,1,1.55,1.55,0,0,0,1,.27C249,61.17,249.43,61.05,249.45,61.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.19,57.72a12.93,12.93,0,0,1-1.38,3.41h0l-.22.45-.24-.42a13.23,13.23,0,0,1-1.64-3.3,12.93,12.93,0,0,1,2.08,3l-.46,0h0A13.8,13.8,0,0,1,253.19,57.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.29,71.79a8.75,8.75,0,0,0-1.38-1.55,7.4,7.4,0,0,0-4.55-1.76,6.42,6.42,0,0,0-4.52,1.7,13.18,13.18,0,0,0-1.36,1.58,2,2,0,0,1,.24-.52,6.21,6.21,0,0,1,1-1.22,6.36,6.36,0,0,1,4.69-1.85,7.11,7.11,0,0,1,4.68,1.91,6,6,0,0,1,1,1.19A1.33,1.33,0,0,1,239.29,71.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.74,60.6a1.63,1.63,0,0,1,.81-.33,3,3,0,0,1,2.28.62,4,4,0,0,1,1.42,3.18,4.53,4.53,0,0,1-.45,2.07A2.71,2.71,0,0,1,234,67.57a3.33,3.33,0,0,1-2.27-.18A3.63,3.63,0,0,1,230.19,66a3.38,3.38,0,0,1-.5-1.85,5.54,5.54,0,0,1,.24-1.64,3,3,0,0,1,1.46-1.86,2.27,2.27,0,0,1,.83-.26s-.3.09-.77.37a2.94,2.94,0,0,0-1.31,1.81,4.3,4.3,0,0,0,.29,3.28A3.19,3.19,0,0,0,234,67.27,2.42,2.42,0,0,0,235.53,66a4.41,4.41,0,0,0,.43-1.93,3.85,3.85,0,0,0-1.27-3,3,3,0,0,0-2.13-.67A4.19,4.19,0,0,0,231.74,60.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.55,63.13a.17.17,0,0,1,.15.18.18.18,0,0,1-.16.18.16.16,0,0,1-.15-.18A.17.17,0,0,1,234.55,63.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5,63.56a.16.16,0,0,1,.15.18c0,.11-.07.19-.16.18a.18.18,0,0,1,0-.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.88,62.69a2.41,2.41,0,0,1,.81-.07,7.76,7.76,0,0,0,1.89-.21,2.79,2.79,0,0,0,1.57-.91c.28-.38.34-.7.39-.69s.06.34-.2.81a2.7,2.7,0,0,1-1.68,1.09,5.89,5.89,0,0,1-2,.13A1.88,1.88,0,0,1,229.88,62.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.89,65.14s-.11.09-.31.07a.67.67,0,0,1-.56-.53.54.54,0,0,1,.12-.46.48.48,0,0,1,.36-.15c.23,0,.3.17.26.18s-.12,0-.24,0a.28.28,0,0,0-.19.34C229.4,65,229.91,65.05,229.89,65.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.23,64.83c0-.07.28-.25.22-.54S236,64,236,63.91s.07-.12.24-.11a.55.55,0,0,1,.49.42.56.56,0,0,1-.25.6C236.35,64.9,236.23,64.87,236.23,64.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.31,65.22s0,.18-.16.36a1.19,1.19,0,0,1-.85.42,1.23,1.23,0,0,1-.91-.3c-.18-.16-.23-.31-.2-.33s.46.36,1.09.32S234.24,65.17,234.31,65.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.29,65c0-.06.33-.21.43-.63l.15.19a.64.64,0,0,1-.52-.17,1,1,0,0,1-.3-1c0-.24.11-.37.15-.37s.05.16.07.38a1,1,0,0,0,.28.71.46.46,0,0,0,.29.12h.23l-.07.19C233.78,65,233.28,65.07,233.29,65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.55,68.36c-.09,0-.17-.18-.19-.42s0-.43.13-.44.17.18.19.42S232.63,68.35,232.55,68.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.09,68.24c-.08,0-.17-.18-.18-.42s0-.44.13-.44.17.18.18.42S234.18,68.23,234.09,68.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.67,
    y: 76.66,
    width: 34.06,
    height: 48.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.6,91.67a27.09,27.09,0,0,1-5.88,0,27.09,27.09,0,0,1,5.88,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.27,92.9a53.38,53.38,0,0,1-8.26,0,56.93,56.93,0,0,1,8.26,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.27,95.07a56.93,56.93,0,0,1-8.26,0,53.38,53.38,0,0,1,8.26,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.27,97.23a53.38,53.38,0,0,1-8.26,0,53.38,53.38,0,0,1,8.26,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.6,99.39a8.23,8.23,0,0,1-2.29.16,8.33,8.33,0,0,1-2.3-.16,9.1,9.1,0,0,1,2.3-.15A9,9,0,0,1,297.6,99.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,95.18c0,.09-3,.16-6.63.16s-6.64-.07-6.64-.16,3-.16,6.64-.16S318,95.09,318,95.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.18,97.29c0,.09-3,.16-6.63.16s-6.64-.07-6.64-.16,3-.16,6.64-.16S318.18,97.2,318.18,97.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.6,102.11a27.09,27.09,0,0,1-5.88,0,27.09,27.09,0,0,1,5.88,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,105.62c0,.09-3,.16-6.63.16s-6.64-.07-6.64-.16,3-.15,6.64-.15S318,105.54,318,105.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.18,107.73c0,.09-3,.16-6.63.16s-6.64-.07-6.64-.16,3-.15,6.64-.15S318.18,107.65,318.18,107.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.6,113a27.09,27.09,0,0,1-5.88,0,27.09,27.09,0,0,1,5.88,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,116.47c0,.09-3,.16-6.63.16s-6.64-.07-6.64-.16,3-.16,6.64-.16S318,116.38,318,116.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.18,118.58c0,.09-3,.16-6.63.16s-6.64-.07-6.64-.16,3-.16,6.64-.16S318.18,118.49,318.18,118.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.82,86.18c0,.08-3.14.15-7,.15s-7-.07-7-.15,3.14-.16,7-.16S319.82,86.09,319.82,86.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,88.2a41.14,41.14,0,0,1-7,0,38.58,38.58,0,0,1,7,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,84.39s-.22.18-.67.28a1.18,1.18,0,0,1-.81-.15,1.21,1.21,0,0,1-.55-.87A1.24,1.24,0,0,1,307,82.31c.48,0,.73.16.7.19s-.27-.06-.66,0a1,1,0,0,0-.8,1.09,1,1,0,0,0,.4.66,1.07,1.07,0,0,0,.63.17C307.69,84.42,308,84.34,308,84.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.37,82.21a9.5,9.5,0,0,1-.9,2.17h0l-.14.27-.14-.25a9.05,9.05,0,0,1-1.06-2.11,8.92,8.92,0,0,1,1.33,2l-.28,0h0A8.94,8.94,0,0,1,310.37,82.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,89.19a6.13,6.13,0,0,1,0-.66c0-.49,0-1.09,0-1.79,0-1.63,0-3.78-.07-6.31l.13.14-8.75,0s.29-.3.15-.16h0v4.61c0,1.46,0,2.85,0,4.13l-.13-.14,6.3.07,1.8,0,.65,0a4.35,4.35,0,0,1-.6,0l-1.76,0-6.39.06h-.14v-.14c0-1.28,0-2.67,0-4.13,0-.74,0-1.49,0-2.27V80.45h0c-.14.14.19-.19.16-.15l8.75,0h.14v.13c0,2.57-.05,4.74-.07,6.39,0,.7,0,1.28,0,1.77A4.35,4.35,0,0,1,302,89.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.77,82.4a1.17,1.17,0,0,1,.52-.21,2,2,0,0,1,1.46.39,2.57,2.57,0,0,1,.91,2,2.74,2.74,0,0,1-.28,1.32,1.77,1.77,0,0,1-1.13.92,2.25,2.25,0,0,1-2.48-1,2.21,2.21,0,0,1-.31-1.19,3.8,3.8,0,0,1,.15-1,1.92,1.92,0,0,1,.94-1.19,1.48,1.48,0,0,1,.53-.17s-.19.07-.49.24a1.91,1.91,0,0,0-.84,1.16,2.75,2.75,0,0,0,.19,2.1,2,2,0,0,0,2.25.92,1.94,1.94,0,0,0,1.28-2,2.45,2.45,0,0,0-.81-1.93,1.88,1.88,0,0,0-1.36-.43A3.4,3.4,0,0,0,296.77,82.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.54,85.14s.3-.15.29-.45-.38-.35-.38-.39.08-.08.22,0a.47.47,0,0,1,.09.88C299.63,85.2,299.53,85.17,299.54,85.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.55,84.65s-.27.21-.19.5.44.26.45.3-.06.09-.21.09a.48.48,0,0,1-.44-.32.5.5,0,0,1,.17-.53C295.45,84.61,295.55,84.62,295.55,84.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.57,85.26c.06,0-.15.55-.79.64a.83.83,0,0,1-.91-.43,2,2,0,0,0,.89.22C298.27,85.63,298.52,85.22,298.57,85.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,83.18s-.14.15-.45.27a1.06,1.06,0,0,1-.6,0,.72.72,0,0,1-.54-.54l.18.06,0,0a1.92,1.92,0,0,1-1.19.54c-.34,0-.54,0-.53-.07a2.56,2.56,0,0,0,1.57-.62l0,0,.15-.15,0,.2a.55.55,0,0,0,.38.39,1.1,1.1,0,0,0,.51,0C298.77,83.23,299,83.15,299,83.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.84,89.19a7.69,7.69,0,0,0-.76-.81,3.67,3.67,0,0,0-2.46-.77,4,4,0,0,0-2.45.85,5.06,5.06,0,0,0-.73.83s0-.11.11-.28a3,3,0,0,1,.52-.66,3.89,3.89,0,0,1,2.54-.95,3.61,3.61,0,0,1,2.57.87,2.89,2.89,0,0,1,.53.64A.78.78,0,0,1,300.84,89.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.66,85.14s.09-.11.17-.26V85a.89.89,0,0,1-.21-.28c-.19-.34-.15-.67-.09-.67s.11.28.27.57c.05.1.11.19.16.27l0,.06,0,0C297.83,85.16,297.67,85.18,297.66,85.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.85,84.37c-.05,0-.17,0-.29,0s-.21.11-.27.09,0-.25.24-.3S298.9,84.35,298.85,84.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.78,84.57s-.15,0-.28,0-.24,0-.28,0,.07-.19.28-.19S296.82,84.53,296.78,84.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.22,87.76a2.58,2.58,0,0,1-.72.36.79.79,0,0,1-.58-.14,1,1,0,0,1-.41-.6.76.76,0,0,1,0-.42c.05-.13.08-.21,0-.31a.83.83,0,0,1-.14-.89c.16-.32.46-.47.49-.74s0-.6,0-.91a2.56,2.56,0,0,1,.19-.88,1.88,1.88,0,0,1,1-1.06,1.36,1.36,0,0,1,1.34,0,1.94,1.94,0,0,0-1.28.08,1.81,1.81,0,0,0-.92,1,2.32,2.32,0,0,0-.15.8c0,.29.08.58,0,.94s-.42.56-.52.79a.69.69,0,0,0,.12.72.47.47,0,0,1,0,.46.54.54,0,0,0,0,.33.91.91,0,0,0,.34.51.75.75,0,0,0,.86,0A1,1,0,0,1,296.22,87.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.57,88a2,2,0,0,1,.34,0,.59.59,0,0,0,.62-.5,1,1,0,0,0,0-.61.59.59,0,0,1,.08-.41.91.91,0,0,0,.14-.34,1,1,0,0,0-.11-.73c-.13-.23-.35-.44-.52-.72a12.79,12.79,0,0,1-.52-1.66,1.38,1.38,0,0,0-1-.8,9.47,9.47,0,0,0-1.28-.09,3,3,0,0,1,1.32,0,1.52,1.52,0,0,1,1.14.86c.24.51.24,1.13.53,1.63.14.25.37.46.52.73a1.14,1.14,0,0,1,.12.88c-.07.3-.3.47-.23.67a1.13,1.13,0,0,1,0,.68.89.89,0,0,1-.34.47.58.58,0,0,1-.43.07A.77.77,0,0,1,299.57,88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,87.64s-.12-.2-.15-.47,0-.49.06-.49.12.2.15.47S297,87.63,297,87.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.62,86.62c.05,0,.07.22,0,.48s-.12.46-.18.45-.07-.22,0-.48S298.56,86.61,298.62,86.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.06,
    y: 76.66,
    width: 34.06,
    height: 48.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,91.67a27.09,27.09,0,0,1-5.88,0,27.09,27.09,0,0,1,5.88,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.66,92.9a26.56,26.56,0,0,1-4.13.16,26.56,26.56,0,0,1-4.13-.16,29.07,29.07,0,0,1,4.13-.15A29.07,29.07,0,0,1,177.66,92.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.66,95.07a29.07,29.07,0,0,1-4.13.15,29.07,29.07,0,0,1-4.13-.15,26.56,26.56,0,0,1,4.13-.16A26.56,26.56,0,0,1,177.66,95.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.66,97.23a26.56,26.56,0,0,1-4.13.16,26.56,26.56,0,0,1-4.13-.16,26.56,26.56,0,0,1,4.13-.16A26.56,26.56,0,0,1,177.66,97.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,99.39a8.23,8.23,0,0,1-2.29.16,8.33,8.33,0,0,1-2.3-.16,9.1,9.1,0,0,1,2.3-.15A9,9,0,0,1,174,99.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.38,95.18c0,.09-3,.16-6.63.16s-6.64-.07-6.64-.16,3-.16,6.64-.16S194.38,95.09,194.38,95.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.57,97.29c0,.09-3,.16-6.64.16s-6.63-.07-6.63-.16,3-.16,6.63-.16S194.57,97.2,194.57,97.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,102.11a27.09,27.09,0,0,1-5.88,0,27.09,27.09,0,0,1,5.88,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.38,105.62c0,.09-3,.16-6.63.16s-6.64-.07-6.64-.16,3-.15,6.64-.15S194.38,105.54,194.38,105.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.57,107.73c0,.09-3,.16-6.64.16s-6.63-.07-6.63-.16,3-.15,6.63-.15S194.57,107.65,194.57,107.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,113a27.09,27.09,0,0,1-5.88,0,27.09,27.09,0,0,1,5.88,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.38,116.47c0,.09-3,.16-6.63.16s-6.64-.07-6.64-.16,3-.16,6.64-.16S194.38,116.38,194.38,116.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.57,118.58c0,.09-3,.16-6.64.16s-6.63-.07-6.63-.16,3-.16,6.63-.16S194.57,118.49,194.57,118.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.21,86.18c0,.08-3.14.15-7,.15s-7-.07-7-.15,3.15-.16,7-.16S196.21,86.09,196.21,86.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.35,88.2a41.14,41.14,0,0,1-7,0,38.58,38.58,0,0,1,7,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.23,89.14a6.13,6.13,0,0,1,0-.66c0-.49,0-1.09,0-1.79,0-1.63,0-3.78-.07-6.31l.13.14-8.76,0,.16-.16h0v2.34c0,.78,0,1.53,0,2.27,0,1.46,0,2.85,0,4.13l-.14-.14,6.31.07,1.79,0,.66,0a4.35,4.35,0,0,1-.6,0l-1.76,0-6.4.07h-.13v-.14c0-1.28,0-2.67,0-4.13V80.4h0c-.14.14.19-.19.15-.16l8.76,0h.14v.13c0,2.57-.05,4.74-.07,6.39,0,.7,0,1.28,0,1.77A4.35,4.35,0,0,1,178.23,89.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,82.35a1,1,0,0,1,.52-.21,2,2,0,0,1,1.46.39,2.59,2.59,0,0,1,.91,2,2.87,2.87,0,0,1-.28,1.33,1.77,1.77,0,0,1-1.14.92,2.23,2.23,0,0,1-2.47-1,2.13,2.13,0,0,1-.31-1.19,3.46,3.46,0,0,1,.15-1,1.92,1.92,0,0,1,.94-1.19,1.48,1.48,0,0,1,.53-.17s-.19.06-.49.24A1.88,1.88,0,0,0,172,83.6a2.71,2.71,0,0,0,.19,2.1,2,2,0,0,0,2.25.92,1.94,1.94,0,0,0,1.28-2,2.45,2.45,0,0,0-.81-1.93,1.88,1.88,0,0,0-1.36-.43A3.4,3.4,0,0,0,173,82.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.78,85.09s.31-.15.3-.45-.38-.35-.38-.39.08-.08.22,0a.49.49,0,0,1,.36.42.46.46,0,0,1-.27.47C175.87,85.15,175.78,85.12,175.78,85.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.8,84.6s-.27.21-.19.5.44.26.45.3-.06.09-.21.09a.47.47,0,0,1-.27-.85C171.7,84.56,171.79,84.57,171.8,84.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.81,85.21c.07,0-.14.54-.78.64s-1-.42-.91-.43a2,2,0,0,0,.89.22C174.52,85.58,174.77,85.17,174.81,85.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.21,83.13s-.14.15-.45.26a1,1,0,0,1-.6,0,.71.71,0,0,1-.54-.54l.18.06,0,0a1.86,1.86,0,0,1-1.18.55c-.34,0-.54,0-.53-.07a2.56,2.56,0,0,0,1.57-.62l0,0,.15-.15,0,.2a.54.54,0,0,0,.38.39,1,1,0,0,0,.51,0C175,83.18,175.2,83.1,175.21,83.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.09,89.14a9.32,9.32,0,0,0-.76-.81,3.69,3.69,0,0,0-2.46-.77,4,4,0,0,0-2.45.85,6.34,6.34,0,0,0-.74.83.85.85,0,0,1,.12-.28,2.57,2.57,0,0,1,.52-.66,3.89,3.89,0,0,1,2.54-1,3.59,3.59,0,0,1,2.56.87,2.71,2.71,0,0,1,.54.64A.78.78,0,0,1,177.09,89.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.91,85.09s.09-.11.17-.26v.11a1.26,1.26,0,0,1-.2-.28c-.19-.35-.15-.67-.09-.67s.11.28.27.57c.05.1.11.19.16.27l.05.06-.05,0C174.08,85.11,173.92,85.12,173.91,85.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.09,84.32s-.16,0-.28,0-.22.11-.27.09,0-.25.24-.3S175.15,84.3,175.09,84.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,84.52s-.15,0-.28,0-.25,0-.28,0,.07-.19.28-.19S173.07,84.47,173,84.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.21,87.59c-.05,0-.12-.2-.15-.47s0-.49.06-.49.12.2.15.46S173.27,87.58,173.21,87.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.87,86.57s.07.22,0,.48-.12.46-.18.45-.07-.22,0-.48S174.81,86.56,174.87,86.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.62,88.18c-.06,0,.09-.61.13-1.36s0-1.35,0-1.36a3.7,3.7,0,0,1-.16,2.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.24,88a6.27,6.27,0,0,1-.31-1.49,5.33,5.33,0,0,1-.11-1.51,5.49,5.49,0,0,1,.32,1.48A5.6,5.6,0,0,1,176.24,88Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.68,155.31l2.06,33.42a2.27,2.27,0,0,0,2.26,2.12h60.17a2.26,2.26,0,0,0,2.25-2.26v-26a2.25,2.25,0,0,0-2.27-2.25l-37,.23a2.24,2.24,0,0,1-1.6-.65l-6.43-6.33a2.24,2.24,0,0,0-1.59-.65h-15.6A2.26,2.26,0,0,0,213.68,155.31Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.68,155.31l2.06,33.42a2.27,2.27,0,0,0,2.26,2.12h60.17a2.26,2.26,0,0,0,2.25-2.26v-26a2.25,2.25,0,0,0-2.27-2.25l-37,.23a2.24,2.24,0,0,1-1.6-.65l-6.43-6.33a2.24,2.24,0,0,0-1.59-.65h-15.6A2.26,2.26,0,0,0,213.68,155.31Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.88,169.28l5,41a1.46,1.46,0,0,0,1.44,1.27h64.07a1.45,1.45,0,0,0,1.45-1.34l3.22-41a1.45,1.45,0,0,0-1.44-1.57H211.32A1.45,1.45,0,0,0,209.88,169.28Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.77,173.65l2.16,28.43a1.93,1.93,0,0,0,1.94,1.78l51.24-.73a1.92,1.92,0,0,0,1.9-1.94L187.69,179a1.9,1.9,0,0,0-2-1.89l-31.51.64a1.93,1.93,0,0,1-1.37-.53l-5.55-5.32a1.89,1.89,0,0,0-1.36-.53l-13.28.19A1.92,1.92,0,0,0,130.77,173.65Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.87,
    y: 174.13,
    width: 55.99,
    height: 33.46,
    transform: "translate(-2.68 2.28) rotate(-0.81)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.22,177.59,132,212.42a1.25,1.25,0,0,0,1.24,1.07l54.56-.78a1.23,1.23,0,0,0,1.22-1.15l2.25-34.93a1.23,1.23,0,0,0-1.25-1.31l-61.58.87A1.24,1.24,0,0,0,127.22,177.59Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.49,171.23,314.6,199a1.86,1.86,0,0,0,1.9,1.73l50.05-.7a1.88,1.88,0,0,0,1.85-1.91l-.3-21.65a1.89,1.89,0,0,0-1.92-1.85l-30.78.63a1.9,1.9,0,0,1-1.34-.52l-5.42-5.19a1.88,1.88,0,0,0-1.33-.53l-13,.19A1.87,1.87,0,0,0,312.49,171.23Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.49,171.23,314.6,199a1.86,1.86,0,0,0,1.9,1.73l50.05-.7a1.88,1.88,0,0,0,1.85-1.91l-.3-21.65a1.89,1.89,0,0,0-1.92-1.85l-30.78.63a1.9,1.9,0,0,1-1.34-.52l-5.42-5.19a1.88,1.88,0,0,0-1.33-.53l-13,.19A1.87,1.87,0,0,0,312.49,171.23Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.56,
    y: 171.7,
    width: 54.7,
    height: 32.68,
    transform: "translate(-2.63 4.84) rotate(-0.81)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,175.08l4.66,34a1.21,1.21,0,0,0,1.22,1.05l53.29-.76a1.2,1.2,0,0,0,1.19-1.13l2.2-34.11a1.2,1.2,0,0,0-1.22-1.29l-60.16.85A1.21,1.21,0,0,0,309,175.08Z",
    style: {
      fill: "#e5c15c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.38,217.69,226,220.24l-4.93-7.74,2.88-6c.28-.56.57-1.18.88-1.89a8,8,0,0,0,.63-2.63,12.68,12.68,0,0,0-.08-3.36c-.27-1,.79-1.82,1.5-1.24s1.52,3.31,1,6.61,3.3-.2,4.72-1.45,6-4.9,6.7-4.76c1.05.21,1,1.41-.42,2.62s-5.53,5.16-4.86,5.89h0a4,4,0,0,1,3.5,3.13c.37,1.62.66,3.86-.25,4.6A53.55,53.55,0,0,1,231.38,217.69Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.31,148.72,126.18,190l17.71.85.51-10s6.29,1.25,7.92-4.6c1-3.73.77-32.57.77-32.57Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.09,147.72c-1.19,2.46-6.87,7-6.87,7l-2.57,6.87c-2.22-1.74-5.22-1.64-5.78,2.27-.41,2.83,3.11,3.41,3.11,3.41-2,3.48-3.44,6.3-6.42,9.62-3.23,3.59-5,3.95-8.54,4h-3.86s-7.9-6.6-6.34-24,17.19-12.31,20.92-16.66C146.82,133.16,161.08,139.48,157.09,147.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.7,171.43h.49a8.35,8.35,0,0,0,1.4-.16,10.05,10.05,0,0,0,4.53-2.41,25.18,25.18,0,0,0,4.59-6.15c1.5-2.46,3.14-5.36,6-7.31a14.38,14.38,0,0,1,4.53-1.93c1.54-.4,3.05-.64,4.47-.92a16.79,16.79,0,0,0,7.15-2.67,7.73,7.73,0,0,0,2.9-4.17,6.73,6.73,0,0,0,.16-1.89s0,.17.05.49a5.43,5.43,0,0,1-.14,1.42,7.71,7.71,0,0,1-2.88,4.27,16.88,16.88,0,0,1-7.2,2.74c-2.82.58-6.12,1-8.92,2.83s-4.41,4.78-5.92,7.24a25,25,0,0,1-4.65,6.16,10,10,0,0,1-4.61,2.38A5.8,5.8,0,0,1,120.7,171.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.46,351.12l7.2,110.13,16.71-1.85S160.78,352,160,352.1,136.46,351.12,136.46,351.12Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.42 350.46 82.63 459.64 97.48 461.9 123.51 355.65 101.42 350.46",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.97 281.85 81.33 429.04 111.05 435.48 133.61 312.79 138.66 432.16 166.26 432.16 161.3 277.34 106.97 281.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.45,436.08l-30.69-6.65.08-.47,25.7-147.58.39,0,54.86-4.55v.52l5,155.34h-28.6l0-.47L133.3,317.25Zm-29.54-7.43,28.74,6.23,23.27-126.55,5.22,123.33h26.61l-4.93-153.78-53.43,4.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.45,312.64a4.38,4.38,0,0,1-1,.14l-2.75.21c-2.33.16-5.55.32-9.09.67s-6.72.82-9,1.12l-2.74.34a3.45,3.45,0,0,1-1,.05,4.11,4.11,0,0,1,1-.25c.64-.13,1.57-.31,2.72-.51,2.31-.39,5.49-.92,9.05-1.27s6.79-.45,9.12-.52c1.17,0,2.11,0,2.77,0A3.37,3.37,0,0,1,141.45,312.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.88,301.3a1.89,1.89,0,0,1-.69.19,9.62,9.62,0,0,1-1.93.09,11.13,11.13,0,0,1-9.87-7.09,9.17,9.17,0,0,1-.53-1.86,1.76,1.76,0,0,1,0-.71c.09,0,.25,1,.91,2.42a11.66,11.66,0,0,0,9.56,6.87C160.87,301.38,161.86,301.21,161.88,301.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.65,426c0,.14-6.24-.06-13.92-.45s-13.91-.82-13.9-1,6.24.06,13.93.45S166.66,425.85,166.65,426Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9,426.73a5.74,5.74,0,0,1-1.18-.29l-3.16-.95c-2.67-.8-6.36-1.86-10.48-2.9s-7.88-1.85-10.6-2.41l-3.24-.67a5,5,0,0,1-1.17-.3,6.8,6.8,0,0,1,1.21.1c.77.1,1.89.27,3.26.5,2.75.47,6.54,1.23,10.67,2.27s7.82,2.17,10.46,3.06c1.32.44,2.39.82,3.11,1.11A6.2,6.2,0,0,1,112.9,426.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.33,291.72h58.15l-2.25-47c-.37-9.24-.32-10.34-.55-18.86,0,0,8.69,10.49,15.51,17.85a13.92,13.92,0,0,0,16.15,3.1l35.73-24.93-6.69-17.11-32.47,19.87c-1.49-.92-14.13-18.95-22.86-27.75A30.88,30.88,0,0,0,144,187.78a152.76,152.76,0,0,0-19.72.79,20.62,20.62,0,0,0-18.36,18.81c-.64,7.54-.13,16.3-.13,31.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.68,192.88c-5.48,2.43-28.38,31.77-30,50.82-1.21,14.21,26.43,12.66,26.43,12.66s1.88-58.28,1.06-57.45",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.08,197.85s0,.21,0,.61-.09,1-.14,1.74c-.12,1.51-.28,3.71-.42,6.42-.31,5.42-.57,12.92-.83,21.21s-.49,15.79-.77,21.21c-.13,2.72-.27,4.91-.38,6.43q-.09,1.07-.15,1.74c0,.4-.06.61-.06.61s0-.21,0-.61.06-1,.1-1.75c.08-1.58.19-3.76.32-6.42.24-5.43.45-12.93.71-21.22s.54-15.79.89-21.21c.17-2.71.34-4.9.49-6.42.07-.71.13-1.28.17-1.74S108.08,197.85,108.08,197.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,235.24a8,8,0,0,1-.78,1.09c-.52.65-1.25,1.54-2.1,2.47s-1.65,1.76-2.25,2.33a7.13,7.13,0,0,1-1,.89,10.11,10.11,0,0,1,.9-1c.58-.6,1.36-1.43,2.21-2.37s1.59-1.8,2.13-2.42A9.82,9.82,0,0,1,105.82,235.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.57,230.42a3.4,3.4,0,0,1,.12-.84c.1-.52.26-1.23.44-2s.36-1.49.5-2a4.23,4.23,0,0,1,.26-.81,3.4,3.4,0,0,1-.12.85c-.1.51-.25,1.22-.44,2s-.35,1.48-.49,2A3.19,3.19,0,0,1,186.57,230.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.83,230.92a25.41,25.41,0,0,1-.84-3.21,28.12,28.12,0,0,1-.64-3.26,26,26,0,0,1,.84,3.21A28.12,28.12,0,0,1,189.83,230.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.19,227.37l-.33-.3-.94-.91c-.8-.79-2-1.94-3.36-3.41a55,55,0,0,1-4.56-5.44,31.3,31.3,0,0,1-4.15-7.63,21.43,21.43,0,0,1-1.37-8.56,17.61,17.61,0,0,1,1.54-6.91,10.14,10.14,0,0,1,3-3.69,9.8,9.8,0,0,1,1.09-.72,4.28,4.28,0,0,1,.4-.21s-.55.3-1.44,1a10.29,10.29,0,0,0-2.92,3.7,17.83,17.83,0,0,0-1.49,6.85,21.24,21.24,0,0,0,1.38,8.48c2.14,5.8,5.93,10.08,8.62,13,1.37,1.48,2.52,2.64,3.31,3.45l.91.94C161.09,227.25,161.19,227.37,161.19,227.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.34,197.51c0,.14-12.56.26-28.06.26s-28.06-.12-28.06-.26,12.56-.26,28.06-.26S165.34,197.36,165.34,197.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.25,205.65c0,.14-15.62.26-34.88.26s-34.89-.12-34.89-.26,15.62-.26,34.89-.26S172.25,205.5,172.25,205.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.82,214.07c0,.15-18.8.26-42,.26s-42-.11-42-.26,18.79-.26,42-.26S180.82,213.93,180.82,214.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.71,223.06c0,.14-21.5.26-48,.26s-48-.12-48-.26,21.49-.26,48-.26S186.71,222.91,186.71,223.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,233.45a6.42,6.42,0,0,1-.76.05l-2.15.05-7.92.08-26.15.08-26.15-.08-7.92-.08-2.15-.05a6.42,6.42,0,0,1-.76-.05,3.75,3.75,0,0,1,.76-.06l2.15,0,7.92-.08,26.15-.08,26.15.08,7.92.08,2.15,0A3.75,3.75,0,0,1,159.87,233.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.58,234c0,.14-9.93.26-22.18.26s-22.18-.12-22.18-.26,9.93-.26,22.18-.26S210.58,233.86,210.58,234Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.42,243.27c0,.15-4.82.26-10.75.26s-10.75-.11-10.75-.26,4.81-.26,10.75-.26S196.42,243.13,196.42,243.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.06,223.9c0,.14-7.36.26-16.43.26s-16.43-.12-16.43-.26,7.36-.26,16.43-.26S224.06,223.75,224.06,223.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.55,244.33c0,.14-17.31.26-38.65.26s-38.65-.12-38.65-.26,17.3-.26,38.65-.26S160.55,244.19,160.55,244.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.19,256.41c0,.15-12.62.26-28.18.26s-28.19-.11-28.19-.26,12.62-.26,28.19-.26S161.19,256.27,161.19,256.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.19,266.15c0,.14-12.62.26-28.18.26s-28.19-.12-28.19-.26,12.62-.26,28.19-.26S161.19,266,161.19,266.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.19,277.34c0,.14-12.62.26-28.18.26s-28.19-.12-28.19-.26,12.62-.26,28.19-.26S161.19,277.19,161.19,277.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2,216.91c0,.14-5.15.26-11.51.26s-11.51-.12-11.51-.26,5.15-.26,11.51-.26S224.2,216.77,224.2,216.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.91 456.41 80.39 466.63 97.77 468.59 98.4 458.46 82.91 456.41",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.76,456.91a21.5,21.5,0,0,1-.57,4.7,21.93,21.93,0,0,1-1.09,4.61,21.5,21.5,0,0,1,.57-4.69A22.13,22.13,0,0,1,90.76,456.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.84,467.47a14.3,14.3,0,0,1-2.52-.28l-6-.89c-2.35-.36-4.48-.72-6-1a12.15,12.15,0,0,1-2.45-.62,13.78,13.78,0,0,1,2.52.29l6,.89c2.35.35,4.48.71,6,1A12.15,12.15,0,0,1,97.84,467.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4,460.93l-.06-2-19,.47.12,6.64,1.17.05c5.22.17,26.52.5,30-.63C178.51,464.18,162.4,460.93,162.4,460.93Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.35,465.72a6.48,6.48,0,0,0-2.5-4,6.34,6.34,0,0,0-4.44-1.28l.12,5.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.28,462.8s5.65,1.5,5,2.44-22.22,1.41-31.74.79l0-.43,25.13-.33S169.18,462.87,170.28,462.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.24,465.6l.32,0,.93,0,3.44.08c2.89,0,6.9,0,11.32-.05s8.43-.27,11.32-.43L174,465l.93-.08.32,0h-.33l-.93,0-3.43.14c-2.89.13-6.89.27-11.31.37s-8.42.11-11.32.11h-4.37A2,2,0,0,0,143.24,465.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.66,465.56a8,8,0,0,1,.61-1.65,7.51,7.51,0,0,1,1.14-1.34,2.51,2.51,0,0,0-1.34,1.22A2.62,2.62,0,0,0,168.66,465.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,462.86c.05,0,.31-.3.57-.74a2.06,2.06,0,0,0,.39-.85c-.06,0-.32.29-.58.73S163,462.83,163,462.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.49,462.08c0,.05.34-.15.66-.45s.54-.58.49-.63-.33.16-.65.46S161.45,462,161.49,462.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.49,460.33a2.39,2.39,0,0,0,1,.1c.55,0,1-.06,1-.13a2.27,2.27,0,0,0-1-.1C160.93,460.21,160.48,460.26,160.49,460.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.13,459.08a2.82,2.82,0,0,0,2.23.12,5.69,5.69,0,0,0-1.12-.06A5.1,5.1,0,0,0,160.13,459.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.64,461.2a3.66,3.66,0,0,0,1.21,0,7.2,7.2,0,0,0,1.29-.31,3.78,3.78,0,0,0,.73-.32.63.63,0,0,0,.29-.38.48.48,0,0,0-.19-.48,2.25,2.25,0,0,0-3.12,1.53c0,.2,0,.32,0,.32a3.28,3.28,0,0,1,.53-1,2.18,2.18,0,0,1,1-.7,1.92,1.92,0,0,1,1.45.07c.19.14.12.37-.09.5a3.79,3.79,0,0,1-.68.3,9,9,0,0,1-1.24.36C164.1,461.15,163.64,461.16,163.64,461.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,461.25a1.2,1.2,0,0,0,.13-.84,2.05,2.05,0,0,0-.35-.88,1.23,1.23,0,0,0-1-.6.49.49,0,0,0-.36.57,1.46,1.46,0,0,0,.22.54,3.79,3.79,0,0,0,.59.72c.39.36.69.5.7.47s-.24-.21-.59-.58a4.48,4.48,0,0,1-.52-.72c-.17-.25-.3-.71,0-.77s.62.26.81.49a2.22,2.22,0,0,1,.36.79A4.17,4.17,0,0,1,164,461.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.51,460.43s.54-.06,1.39,0a6,6,0,0,1,3.07,1.18,6.14,6.14,0,0,1,2,2.65c.31.8.35,1.34.39,1.34a1.12,1.12,0,0,0,0-.38,4.5,4.5,0,0,0-.23-1,5.71,5.71,0,0,0-5.17-3.93,4.41,4.41,0,0,0-1,0A1.37,1.37,0,0,0,143.51,460.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.68,463.83a15.07,15.07,0,0,0,5.52-.07c0-.06-1.24,0-2.76.06S152.69,463.77,152.68,463.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,463.91c-.05,0,.1.26.23.54s.21.53.28.52.09-.3-.07-.62S149,463.86,149,463.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.55,462.2c0,.05.09.24.29.44s.39.31.44.27-.09-.24-.29-.44S147.6,462.16,147.55,462.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.54,461.46c0,.06.27.05.55.14s.48.24.53.19-.12-.3-.46-.4S145.52,461.4,145.54,461.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.12,461.11c0,.06.08.16.24.21s.31.06.33,0-.09-.15-.25-.21S144.14,461.05,144.12,461.11Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeFolder);
export default __webpack_public_path__ + "static/media/resume-folder.62a4ad21f1861926fd1054c149d5add5.svg";
export { ForwardRef as ReactComponent };